import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-multiple-choice',
  templateUrl: './disable-multiple-choice.component.html',
  styleUrls: ['./disable-multiple-choice.component.css'],
})
export class DisableMultipleChoiceComponent {
  @Input() question!: Question;
}
